import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';
const SpotifyIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.359-.66.48-1.021.24-2.82-1.74-6.36-2.101-10.561-1.141-.418.122-.779-.179-.899-.539-.12-.421.18-.78.54-.9 4.56-1.021 8.52-.6 11.64 1.32.42.18.479.659.301 1.02zm1.44-3.3c-.301.42-.841.6-1.262.3-3.239-1.98-8.159-2.58-11.939-1.38-.479.12-1.02-.12-1.14-.6-.12-.48.12-1.021.6-1.141C9.6 9.9 15 10.561 18.72 12.84c.361.181.54.78.241 1.2zm.12-3.36C15.24 8.4 8.82 8.16 5.16 9.301c-.6.179-1.2-.181-1.38-.721-.18-.601.18-1.2.72-1.381 4.26-1.26 11.28-1.02 15.721 1.621.539.3.719 1.02.419 1.56-.299.421-1.02.599-1.559.3z"/>
  </svg>
);

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
    <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
  </svg>
);

const socialLinks = [
  {
    name: 'Spotify',
    icon: SpotifyIcon,
    url: 'https://open.spotify.com/show/1VnoF1p9A8NpZlHGFv60B3?si=NwChlsmVQR2MOP-JsaMNNA',
    color: 'hover:text-green-400'
  }
];

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);
  const [isAppInstalled, setIsAppInstalled] = useState(false);
  const [showInstructions, setShowInstructions] = useState<'android' | 'ios' | null>(null);

  useEffect(() => {
    const handler = (e: Event) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsAppInstalled(true);
    }
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleAndroidClick = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') setIsAppInstalled(true);
      setDeferredPrompt(null);
    } else {
      setShowInstructions('android');
    }
  };

  const handleIOSClick = () => {
    setShowInstructions('ios');
  };
  
  return (
    <footer className="relative py-10 sm:py-16 bg-slate-900 text-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex flex-col items-center justify-center space-y-6 sm:space-y-8">
          {/* Logo */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
          >
            <h2 className="text-xl font-bold">
              Faceless Aura <span className="text-blue-400">Club</span>
            </h2>
          </motion.div>

          {/* Social Media Links */}
          <motion.div
            className="flex justify-center gap-4"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.1 }}
          >
            {socialLinks.map((social) => (
              <a
                key={social.name}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className={`p-3 rounded-full bg-slate-800 text-slate-400 transition-all duration-300 ${social.color} hover:bg-slate-700 hover:scale-110`}
                aria-label={social.name}
              >
                <social.icon />
              </a>
            ))}
          </motion.div>

          {/* Legal Links */}
          <motion.div
            className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-xs text-slate-400"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.2 }}
          >
            <Link to="/terms" className="hover:text-white transition-colors">
              Terms
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors">
              Privacy
            </Link>
            <Link to="/refunds" className="hover:text-white transition-colors">
              Refunds
            </Link>
            <Link to="/legal" className="hover:text-white transition-colors">
              Legal
            </Link>
            <Link to="/cookies" className="hover:text-white transition-colors">
              Cookies
            </Link>
            <Link to="/crypto-policy" className="hover:text-white transition-colors">
              Crypto Policy
            </Link>
            <a href="mailto:hello@auradynamics.management" className="hover:text-white transition-colors">
              Support
            </a>
          </motion.div>

          {/* App Store Buttons */}
          {!isAppInstalled && (
            <motion.div
              className="flex flex-col sm:flex-row items-center gap-3"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.25 }}
            >
              {/* Google Play Button */}
              <button
                onClick={handleAndroidClick}
                className="flex items-center gap-3 px-5 py-2.5 rounded-xl border border-slate-700 bg-slate-800 hover:bg-slate-700 hover:border-slate-500 transition-all group min-w-[180px]"
              >
                <svg viewBox="0 0 24 24" className="w-6 h-6 flex-shrink-0" fill="none">
                  <path d="M3.61 1.814L13.793 12 3.61 22.186a1.12 1.12 0 01-.61-.988V2.802c0-.404.224-.756.61-.988z" fill="#4285F4"/>
                  <path d="M17.4 8.396l-3.607 3.604 3.608 3.604 4.068-2.313a1.12 1.12 0 000-1.978L17.4 8.396z" fill="#FBBC04"/>
                  <path d="M3.61 1.814L13.793 12l3.608-3.604L6.632.396a1.19 1.19 0 00-3.022 1.418z" fill="#34A853"/>
                  <path d="M13.793 12L3.61 22.186a1.19 1.19 0 003.022 1.418L17.4 15.604 13.793 12z" fill="#EA4335"/>
                </svg>
                <div className="text-left">
                  <p className="text-[9px] uppercase tracking-wider text-slate-400 leading-none">Get it on</p>
                  <p className="text-sm font-semibold text-white leading-tight">Google Play</p>
                </div>
              </button>

              {/* App Store Button */}
              <button
                onClick={handleIOSClick}
                className="flex items-center gap-3 px-5 py-2.5 rounded-xl border border-slate-700 bg-slate-800 hover:bg-slate-700 hover:border-slate-500 transition-all group min-w-[180px]"
              >
                <svg viewBox="0 0 24 24" className="w-6 h-6 flex-shrink-0" fill="white">
                  <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                </svg>
                <div className="text-left">
                  <p className="text-[9px] uppercase tracking-wider text-slate-400 leading-none">Download on the</p>
                  <p className="text-sm font-semibold text-white leading-tight">App Store</p>
                </div>
              </button>
            </motion.div>
          )}

          {/* Install Instructions Modal */}
          <AnimatePresence>
            {showInstructions && (
              <motion.div
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                exit={{ opacity: 0 }}
                className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 backdrop-blur-sm p-4"
                onClick={() => setShowInstructions(null)}
              >
                <motion.div
                  initial={{ scale: 0.9, opacity: 0 }}
                  animate={{ scale: 1, opacity: 1 }}
                  exit={{ scale: 0.9, opacity: 0 }}
                  className="bg-slate-900 border border-slate-700 rounded-2xl max-w-sm w-full p-6 relative"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    onClick={() => setShowInstructions(null)}
                    className="absolute top-4 right-4 text-slate-400 hover:text-white transition-colors"
                  >
                    <X className="w-5 h-5" />
                  </button>

                  {showInstructions === 'android' ? (
                    <>
                      <div className="flex items-center gap-3 mb-5">
                        <svg viewBox="0 0 24 24" className="w-8 h-8" fill="none">
                          <path d="M3.61 1.814L13.793 12 3.61 22.186a1.12 1.12 0 01-.61-.988V2.802c0-.404.224-.756.61-.988z" fill="#4285F4"/>
                          <path d="M17.4 8.396l-3.607 3.604 3.608 3.604 4.068-2.313a1.12 1.12 0 000-1.978L17.4 8.396z" fill="#FBBC04"/>
                          <path d="M3.61 1.814L13.793 12l3.608-3.604L6.632.396a1.19 1.19 0 00-3.022 1.418z" fill="#34A853"/>
                          <path d="M13.793 12L3.61 22.186a1.19 1.19 0 003.022 1.418L17.4 15.604 13.793 12z" fill="#EA4335"/>
                        </svg>
                        <h3 className="text-lg font-bold text-white">Install on Android</h3>
                      </div>
                      <ol className="space-y-4 text-sm text-slate-300">
                        <li className="flex gap-3">
                          <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary/20 text-primary flex items-center justify-center font-bold text-xs">1</span>
                          <span>Open this website in <strong className="text-white">Chrome</strong> browser</span>
                        </li>
                        <li className="flex gap-3">
                          <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary/20 text-primary flex items-center justify-center font-bold text-xs">2</span>
                          <span>Tap the <strong className="text-white">⋮ menu</strong> (three dots) in the top right</span>
                        </li>
                        <li className="flex gap-3">
                          <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary/20 text-primary flex items-center justify-center font-bold text-xs">3</span>
                          <span>Tap <strong className="text-white">"Add to Home screen"</strong> or <strong className="text-white">"Install app"</strong></span>
                        </li>
                        <li className="flex gap-3">
                          <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary/20 text-primary flex items-center justify-center font-bold text-xs">4</span>
                          <span>Tap <strong className="text-white">"Install"</strong> to confirm — done! 🎉</span>
                        </li>
                      </ol>
                    </>
                  ) : (
                    <>
                      <div className="flex items-center gap-3 mb-5">
                        <svg viewBox="0 0 24 24" className="w-8 h-8" fill="white">
                          <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                        </svg>
                        <h3 className="text-lg font-bold text-white">Install on iPhone</h3>
                      </div>
                      <ol className="space-y-4 text-sm text-slate-300">
                        <li className="flex gap-3">
                          <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary/20 text-primary flex items-center justify-center font-bold text-xs">1</span>
                          <span>Open this website in <strong className="text-white">Safari</strong> browser</span>
                        </li>
                        <li className="flex gap-3">
                          <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary/20 text-primary flex items-center justify-center font-bold text-xs">2</span>
                          <span>Tap the <strong className="text-white">Share button</strong> (square with arrow ↑) at the bottom</span>
                        </li>
                        <li className="flex gap-3">
                          <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary/20 text-primary flex items-center justify-center font-bold text-xs">3</span>
                          <span>Scroll down and tap <strong className="text-white">"Add to Home Screen"</strong></span>
                        </li>
                        <li className="flex gap-3">
                          <span className="flex-shrink-0 w-7 h-7 rounded-full bg-primary/20 text-primary flex items-center justify-center font-bold text-xs">4</span>
                          <span>Tap <strong className="text-white">"Add"</strong> in the top right — done! 🎉</span>
                        </li>
                      </ol>
                    </>
                  )}
                </motion.div>
              </motion.div>
            )}
          </AnimatePresence>

          {/* Copyright */}
          <motion.p
            className="text-[10px] sm:text-xs tracking-[0.2em] sm:tracking-[0.3em] uppercase text-slate-500"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.3 }}
          >
            © {currentYear} Faceless Aura Club
          </motion.p>

          {/* Tagline */}
          <motion.p
            className="text-[9px] sm:text-[10px] tracking-[0.3em] sm:tracking-[0.5em] uppercase text-slate-600 font-light px-4 text-center"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.4 }}
          >
            Build invisible empires without showing your face.
          </motion.p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
